import React, { useState, useEffect } from 'react';
import './TrainingDashboard.css';
import { BackButton } from '../../../Utilities/components/Buttons';
import Footer from '../../../Footer';
import { SOP_CONTENT } from '../Guides/SOPContents';
import { Link, useLocation } from 'react-router-dom';

const trainingPaths = {
  daycare: ['Daycare'],
  grooming: ['Grooming'],
  frontdesk: ['Front Desk'],
  boarding: ['Boarding'],
  training: ['Training'],
  shuttle: ['Shuttle'],
  manager: ['Manager'],
  all: []
};

const TrainingDashboard = ({ role = 'grooming' }) => {
  const [expandedSections, setExpandedSections] = useState({});
  const [sectionProgress, setSectionProgress] = useState({});
  const [allComplete, setAllComplete] = useState(false);
  const userPath = trainingPaths[role] ? trainingPaths[role] : trainingPaths['all'];

  const toggleSection = function (section) {
    setExpandedSections(function (prev) {
      return Object.assign({}, prev, { [section]: !prev[section] });
    });
  };

  useEffect(function () {
    var newProgress = {};
    var visitedModules = JSON.parse(localStorage.getItem('visitedModules')) || [];
    var totalModules = 0;
    var totalCompleted = 0;

    function calculateProgress(title, concepts) {
      var total = concepts.length;
      var completed = concepts.filter(function (mod) {
        return visitedModules.includes(mod.detailKey);
      }).length;
      totalModules += total;
      totalCompleted += completed;
      return { completed: completed, total: total };
    }

    var coreSection = SOP_CONTENT.find(function (sec) {
      return sec.title.includes('Core');
    });
    if (coreSection) {
      newProgress[coreSection.title] = calculateProgress(coreSection.title, coreSection.coreConcepts);
    }

    userPath.forEach(function (path) {
      var section = SOP_CONTENT.find(function (sec) {
        return sec.title.includes(path);
      });
      if (section) {
        newProgress[section.title] = calculateProgress(section.title, section.coreConcepts);
      }
    });

    setAllComplete(totalModules > 0 && totalModules === totalCompleted);
    setSectionProgress(newProgress);
  }, [role]);

  const handleModuleClick = function (detailKey) {
    var visitedModules = JSON.parse(localStorage.getItem('visitedModules')) || [];
    if (!visitedModules.includes(detailKey)) {
      visitedModules.push(detailKey);
      localStorage.setItem('visitedModules', JSON.stringify(visitedModules));
    }
  };

  const visitedModules = JSON.parse(localStorage.getItem('visitedModules')) || [];

  return (
    <div>
      <div className="container">
        <BackButton />
        <div className='training-dashboard-container'>
          <h2 className="training-header">📘 Training Center</h2>
          <p className="training-role-path">You're on the <span className='highlight-red'>{['Core'].concat(userPath).join(' + ')}</span> training path</p>

          {SOP_CONTENT.filter(function (sec) { return sec.title.includes('Core'); }).map(function (section) {
            var progress = sectionProgress[section.title] || { completed: 0, total: 0 };
            return (
              <div className="training-section" key={section.title}>
                <div className="training-section-title" onClick={function () { toggleSection(section.title); }}>
                  {section.title}
                  <div className="training-progress-bar-wrapper">
                    <div className="training-progress-bar" style={{ width: (progress.completed / progress.total * 100) + '%' }}></div>
                  </div>
                  <div className="training-progress-label">
                    {progress.completed}/{progress.total} completed
                  </div>
                </div>
                {expandedSections[section.title] ? (
                  <div className="training-module-grid">
                    {section.coreConcepts.map(function (mod, index) {
                      var isCompleted = visitedModules.includes(mod.detailKey);
                      return (
                        <Link to={`/console/sop/${mod.detailKey}`} key={index} className="training-module-card-link" onClick={() => handleModuleClick(mod.detailKey)}>
                          <div className={`training-module-card ${isCompleted ? 'completed' : 'not-started'}`}>
                            <div className="training-module-title">{mod.title}</div>
                            <div className={`training-status-badge ${isCompleted ? 'status-completed' : 'status-not-started'}`}>{isCompleted ? 'completed' : 'not started'}</div>
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                ) : null}
              </div>
            );
          })}

          {userPath.map(function (path) {
            var section = SOP_CONTENT.find(function (sec) {
              return sec.title.includes(path);
            });
            if (!section) return null;
            var progress = sectionProgress[section.title] || { completed: 0, total: 0 };
            return (
              <div className="training-section" key={section.title}>
                <div className="training-section-title" onClick={function () { toggleSection(section.title); }}>
                  {section.title}
                  <div className="training-progress-bar-wrapper">
                    <div className="training-progress-bar" style={{ width: (progress.completed / progress.total * 100) + '%' }}></div>
                  </div>
                  <div className="training-progress-label">
                    {progress.completed}/{progress.total} completed
                  </div>
                </div>
                {expandedSections[section.title] ? (
                  <div className="training-module-grid">
                    {section.coreConcepts.map(function (mod, index) {
                      var isCompleted = visitedModules.includes(mod.detailKey);
                      return (
                        <Link to={`/console/sop/${mod.detailKey}`} key={index} className="training-module-card-link" onClick={() => handleModuleClick(mod.detailKey)}>
                          <div className={`training-module-card ${isCompleted ? 'completed' : 'not-started'}`}>
                            <div className="training-module-title">{mod.title}</div>
                            <div className={`training-status-badge ${isCompleted ? 'status-completed' : 'status-not-started'}`}>{isCompleted ? 'completed' : 'not started'}</div>
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                ) : null}
              </div>
            );
          })}

          {allComplete && (
            <div className="training-section exam-section">
              <div className="training-section-title">📝 Exam</div>
              <p className="training-module-desc">
                Great job! You've completed all modules. Click below to take your final assessment and earn your certification.
              </p>
              <div className='training-exam-button-container'>
                <Link to="/exam-form" className="training-exam-button">Take the Exam</Link>
              </div>
            </div>
          )}

          <div className="training-section">
            <div className="training-section-title">🎓 Certificates</div>
            <p className="training-module-desc">
              Complete required modules and exam to receive certificate
            </p>
          </div>

          <div className="training-section">
            <div className="training-section-title">🧰 Training Tools & Resources</div>
            <ul className="training-tools-list">
              <li><a href="/console/guides">Guides & SOPs</a></li>
            </ul>
          </div>
        </div>
      </div>
      <hr />
      <Footer />
    </div>
  );
};

export default TrainingDashboard;